// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"61":"transfer-users","922":"central-logs","945":"dashboard"}[chunkId] || chunkId) + "." + {"61":"5176d02b","179":"3bb768b3","234":"11d53983","627":"1610986a","849":"40667e98","922":"c26bedcc","945":"0007bbff"}[chunkId] + ".js";
};